import React from 'react';
import { Stage, Text, Layer, Rect, Transformer } from 'react-konva';
import BaseImage from 'components/baseImage';
import { IFrameOption } from 'interfaces';
import Konva from 'konva';

export interface FrameProps {
  format: string;
  imageUrl: string | null;
  layers: IFrameOption[];
  onChangeLayer: (index: any, attrs: any) => void
}

interface RectangleProps {
  shapeProps: any,
  isSelected: boolean,
  onSelect: any,
  onChange: any
}

const Rectangle : React.FC<RectangleProps> = ({ shapeProps, isSelected, onSelect, onChange }) => {
  const shapeRef = React.useRef<any>();
  const trRef = React.useRef<any>();

  React.useEffect(() => {
    if (isSelected) {
      // we need to attach transformer manually
      trRef.current.nodes([shapeRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  return (
    <>
      <Rect
        onClick={onSelect}
        onTap={onSelect}
        ref={shapeRef}
        {...shapeProps}
        draggable
        onDragEnd={(e) => {
          onChange({
            ...shapeProps,
            x: e.target.x(),
            y: e.target.y(),
          });
        }}
        onTransformEnd={(e) => {
          const node = shapeRef.current;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();
          console.log(e);
          onChange({
            ...shapeProps,
            x: node.x(),
            y: node.y(),
            rotation: e.currentTarget.attrs.rotation,
            width: node.width() * scaleX,
            height: node.height() * scaleY,
          });
        }}
      />
      {isSelected && (
        <Transformer
          ref={trRef}
          boundBoxFunc={(oldBox, newBox) => {
            // limit resize
            if (newBox.width < 5 || newBox.height < 5) {
              return oldBox;
            }
            return newBox;
          }}
        />
      )}
    </>
  );
};

const Frame: React.FC<FrameProps> = ({ format = "portrait", imageUrl = "", layers = [], onChangeLayer }) => {
  const size = format == "portrait" ? {
    width: 405, height: 720
  } : { width: 720, height: 405 };

  const onDragItemEnd = (evt: Konva.KonvaEventObject<DragEvent>) => {
    onChangeLayer && onChangeLayer(evt.target.id(), evt.target.attrs);
  }
  const [selectedId, selectShape] = React.useState<string | null>();

  const checkDeselect = (e:any) => {
    // deselect when clicked on empty area
    const clickedOnEmpty = e.target === e.target.getStage();
    if (e.target.className == "Image") {
      selectShape(null);
    }
  };

  return (
    <React.Fragment>
      <Stage
        className="canvas"
        width={size.width}
        height={size.height}
        onMouseDown={checkDeselect}
        onTouchStart={checkDeselect}
      >
        <BaseImage width={size.width} height={size.height} imageUrl={imageUrl}></BaseImage>
        <Layer>
          {layers.length > 0 && layers.map((item, index) => {
            switch (item.type) {
              case "text":
                  return <Text
                    id={item.id}
                    draggable
                    x={item.position.x}
                    y={item.position.y}
                    fontSize={Number.parseInt(item.fontSize)}
                    fontFamily={item.font}
                    onDragEnd={onDragItemEnd}
                    key={index}
                    text={item.text}
                    fill={item.color}
                  >
                  </Text>
              case "rect":
                return <Rectangle
                  key={index}
                  shapeProps={{
                    x: item.position.x,
                    y: item.position.y,
                    width: item.size?.width,
                    height: item.size?.height,
                    fill: item.color,
                    id: item.id,
                    rotation: item.rotation
                  }}
                  isSelected={item.id === selectedId}
                  onSelect={() => {
                    selectShape(item.id);
                  }}
                  onChange={(newAttrs: any) => {
                    onChangeLayer(item.id, newAttrs);
                  }}
                ></Rectangle>
              default:
                return null
            };  
          })
          }
      </Layer>

      </Stage>
    </React.Fragment>
  );
};

export default Frame;
